<template>
    <div class="vh-100">
        <div id="loadingPageImport">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
            <center>
                <h4 style="margin-top:15px"><span class="count" id="dataCOunter">0</span>%</h4>
                <h5>Proses impor..</h5>
            </center>
        </div>
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="back">
                    <div class="header-item">
                        <img src="../../../assets/img/x2.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Impor Data Absensi</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper main-page">
            <div class="w-limit p-x-20 p-t-16 p-d-20">
                <div class="wrapper">
                    <label for="radio1" class="form-label">Absensi pada:</label>
                    <div class="radio-group">
                        <div class="radio-wrapper">
                            <div class="radio-item" @click="Outletactive">
                                <input type="radio" id="radio1" name="radioboxx" v-model="Jenis_Absensi">
                                <label for="radio1">Outlet</label>
                            </div>
                            <div class="radio-item" @click="Workshopactive">
                                <input type="radio" id="radio2" name="radioboxx" v-model="Jenis_Absensi">
                                <label for="radio2">Workshop</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-t-16 mod" v-if="Jenis_Absensi===1">
                    <label class="form-label require" for="select2">Pilih Outlet</label>
                    <Select2 class="test-select fl-is-required inputs" id="select2" v-model="selectedOutlet_absensi"
                             :settings="{ placeholder: 'Pilih Outlet' }" :options="OptionOutlet_absensi"
                             @select="checkselectrequiredoutlet"/>
                </div>
                <div class="m-t-16 mod" v-else>
                    <label class="form-label require" for="select2sec">Pilih Workshop</label>
                    <Select2 class="test-select fl-is-required inputs" id="select2sec"
                             v-model="selectedWorkshop_absensi" :settings="{ placeholder: 'Pilih Workshop' }"
                             :options="OptionWorkshop_absensi"/>
                </div>
            </div>
            <div class="separator"></div>
            <div class="w-limit p-x-20 p-y-16">
                <div class="f-16">
                    File yang diupload harus berupa file excel dengan format penulisan sesuai dengan contoh berikut:
                </div>
                <div class="m-t-16 grey-btn" @click="cekconnection_templeteabsensi">
                    <div class="icon-24 icon-dl"></div>
                    <div class="f-semi f-c-blue m-l-8">Template Data Absensi</div>
                </div>
                <div class="m-t-16 f-16">
                    Jika sudah sesuai dengan template, silahkan upload file melalui kotak dibawah ini.
                </div>
                <div class="line-patah mar-bottom-20">
                  <div class="atribute" id="imagePreview">
                    <label for="importLayanan">
                      <img src="../../../assets/icons/file-plus.svg" alt=""
                           style="max-width: 70px" id="logo">
                      <div>Klik untuk upload...</div>
                    </label>
                    <input type='file' id="importLayanan" ref="file" v-on:change="importdataAbsen"
                           accept=".xlsx"/>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Select2 from 'v-select2-component';

    export default {
        name: 'ImporAbsen',
        components: {
            Select2
        },
        data() {
            return {
                selectedOutlet_absensi: '',
                OptionOutlet_absensi: [],
                selectedWorkshop_absensi: '',
                OptionWorkshop_absensi: [],
                Jenis_Absensi: 1,
                url_import_template: this.$template_import_absensi_url,
                fileImportAbsen: '',
                myVarLoopingFuncAbsen: '',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.Outletactive();
            this.listoutlet()
            this.getlistWorkshop()
        },
        methods: {
            back() {
                this.$emit("showkaryawanlist")
            },
            checkselectrequiredoutlet() {
                var selectLayanan = this.selectedOutlet_absensi;
                if (selectLayanan !== '') {
                    $('#file').prop('disabled', false);
                } else {
                    $('#file').prop('disabled', true);
                }
            },
            Outletactive() {
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_Absensi = 1;
                $("#radio1").prop("checked", true);
                $("#radio2").prop("checked", false);  
                this.checkselectrequiredoutlet();
            },
            Workshopactive() {
                var value = $("input[name=radioboxx]:checked").val();
                this.Jenis_Absensi = 2;
                $("#radio1").prop("checked", false);
                $("#radio2").prop("checked", true);
            },
            async cekconnection_templeteabsensi() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi', {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        }
                    })
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            window.open(this.url_import_template, '_blank');
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                        } else {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.$toast.error(response.data.msg)
                            
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async getlistWorkshop() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                this.OptionWorkshop_absensi = [];
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_meta?idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var rawworkshop = res.data.data;
                        this.OptionWorkshop_absensi.push({id: "", text: "Pilih Workshop"})
                        for (var i = 0; i < rawworkshop.length; i++) {
                            this.OptionWorkshop_absensi.push({
                                id: rawworkshop[i].idworkshop,
                                text: rawworkshop[i].nama
                            })
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async listoutlet() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                this.OptionOutlet_absensi = [];
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_meta?limit=50&idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var rawoutlet = res.data.data;
                        this.OptionOutlet_absensi.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawoutlet.length; i++) {
                            this.OptionOutlet_absensi.push({id: rawoutlet[i].idoutlet, text: rawoutlet[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async importdataAbsen() {
                $('#loadingPageImport').addClass('overlayLoading');
                $('#loadingPageImport').addClass('show-import');
                this.fileImportAbsen = this.$refs.file.files[0];
                var idlokasi
                if (this.Jenis_Absensi === 1) {
                    idlokasi = this.selectedOutlet_absensi
                } else {
                    idlokasi = this.selectedWorkshop_absensi
                }
                try {
                    const updatedata = new FormData()
                    updatedata.append('fileExcel', this.fileImportAbsen);
                    updatedata.append('idlokasi', idlokasi);
                    updatedata.append('lokasi', this.Jenis_Absensi);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/import_data_absen_karyawan'
                        , updatedata, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.trackImportdataAbsensi();
                            this.myVarLoopingFuncAbsen = setInterval(() => {
                                this.trackImportdataAbsensi();
                            }, 5000);
                        } else {
                            $('#loadingPageImport').removeClass('overlayLoading');
                            $('#loadingPageImport').removeClass('show-import');
                            this.$toast.error(response.data.msg)
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                    $('#loadingPageImport').removeClass('overlayLoading');
                    $('#loadingPageImport').removeClass('show-import');
	                this.isClicked2 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },
            async trackImportdataAbsensi() {
                this.fileImportAbsen = this.$refs.file.files[0];
                $("#file").val("")
                try {
                    const updatedata = new FormData()
                    updatedata.append('fileExcel', this.fileImportAbsen)
                    const response = await this.$axios.get(this.$baseurl + '/masterData/karyawan/track_import_data_absen_karyawan', this.requestHeaders)
                    this.fileImportAbsen = '';
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            if (response.data.data.status_progress === '0') {
                                var length = response.data.data.lenght_data
                                var progress = response.data.data.progress_looping
                                var getPercen = (progress / length) * 100;
                                var oldData = $("#dataCOunter").text()
                                $("#dataCOunter").text(getPercen.toFixed(2))
                                // this.counter(oldData)
                                // $("#dataCOunter").text(oldData)
                            } else if (response.data.data.status_progress === '1') {
                                $('#loadingPageImport').removeClass('overlayLoading');
                                $('#loadingPageImport').removeClass('show-import');
                                clearInterval(this.myVarLoopingFuncAbsen);
                                this.back();
                                var length = response.data.data.lenght_data;
                                var progress = response.data.data.progress_looping;
                                var getPercen = (progress / length) * 100;
                                var oldData = $("#dataCOunter").text();
                                $("#dataCOunter").text(getPercen.toFixed());
                                // this.counter(oldData);
                                // $("#dataCOunter").text(oldData);
                                this.$toast.success(response.data.data.msg_progress)
                            } else if (response.data.data.status_progress === '2') {
                                $('#loadingPageImport').removeClass('overlayLoading');
                                $('#loadingPageImport').removeClass('show-import');
                                clearInterval(this.myVarLoopingFuncAbsen);
                                $("#dataCOunter").text(0);
                                this.$toast.error(response.data.data.msg_progress)
                            }
                        } else {
                            $("#dataCOunter").text(0)
                            if (response.data.data.status_progress === '3') {
                                $('#loadingPageImport').removeClass('overlayLoading');
                                $('#loadingPageImport').removeClass('show-import');
                                clearInterval(this.myVarLoopingFuncAbsen);
                                this.$toast.error(response.data.data.msg_progress)
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                    $('#loadingPageImport').removeClass('overlayLoading');
                    $('#loadingPageImport').removeClass('show-import');
	                this.isClicked2 = false
	                $('#textBtnother').show()
	                $('#anotherButton').prop('disabled', false);
                }
            },
            counter(args) {
                $(".count").prop('Counter', 0).animate({
                    Counter: $(".count").text()
                }, {
                    duration: 5000,
                    easing: 'swing',
                    step: function (now) {
                        var data = Math.ceil(now)
                        if (now >= args) {
                            $(".count").text(data);
                        }
                        if (data == 100) {
                            setTimeout(() => {
                                $('#loadingPageImport').removeClass('overlayLoading');
                                $('#loadingPageImport').removeClass('show-import');
                            }, 4000)

                        }
                    }
                });
            },
        }
    }
</script>
<style>
    .atribute .img_upload {
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 32px;
    }

    .show-import {
        display: block !important;
    }

    #loadingPageImport {
        display: none;
    }
</style>